// @core/api/endpoints/workflow/pause_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PauseScheduleRequest,
  PipelineScheduleResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Pause schedule
 * Pauses an active schedule. The next_run_at is preserved for when the schedule is resumed.
 */
export async function PauseSchedule(
  schedule_id: string,
  data: PauseScheduleRequest,
  options?: RequestOptions
): Promise<PipelineScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/schedules/:schedule_id/pause`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.post<PipelineScheduleResponse>(requestPath, data, requestOptions);
}
